/** Keys in the `common` translation namespace, without the namespace prefix. */
export const PLAYBACK_DECISION_LABEL_KEYS = {
    directplay: 'playback.directPlay',
    copy: 'playback.directStream',
    transcode: 'playback.transcode',
};
/** Any copied stream makes the whole session a Direct Stream. */
export function playbackDecision(session) {
    if (session.isTranscode)
        return 'transcode';
    return session.videoDecision === 'copy' || session.audioDecision === 'copy'
        ? 'copy'
        : 'directplay';
}
//# sourceMappingURL=playbackDecision.js.map